/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {CheckRestrictionsForTransferRequest} from '@cash-web/protos/squareup/cash/crow/api/v1beta1/check_restrictions_for_transfer.pb'
import {CheckRestrictionsForTransferResponse} from '@cash-web/protos/squareup/cash/crow/api/v1beta1/check_restrictions_for_transfer.pb'


export const checkRestrictionsForTransfer = (request: CheckRestrictionsForTransferRequest, options?: CashRequestOptions) => post<CheckRestrictionsForTransferRequest, CheckRestrictionsForTransferResponse>("/2.0/cash/check-restrictions-for-transfer", request, {...options, rejectOnError: true })